import axiosInstance from "../helpers/axiosInstance";

export const enqueuePutawayToLocations = async (data) => {
    const res = await axiosInstance.post(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/user-async-tasks/putaway-to-locations`,
        data
    )
    return res.data
}

export const getPutawayToLocationsStatus = async (jobId) => {
    const res = await axiosInstance.get(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/user-async-tasks/putaway-to-locations-status/${jobId}`
    )
    return res.data
}
